import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AlignCenterOutlined, AppstoreOutlined, BlockOutlined, CheckOutlined, ClockCircleOutlined, EnvironmentOutlined, FieldTimeOutlined, HourglassOutlined, KeyOutlined, ProjectOutlined, QuestionCircleOutlined, SaveOutlined, SearchOutlined, SortDescendingOutlined, TagsOutlined, UserOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Button, Col, Collapse, DatePicker, Form, Input, message, Popconfirm, Radio, Row, Select, Space, Tooltip } from 'antd';
import { SortDir, TaskSortType } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getTaskSearchesStore } from 'core/modules/tasks/task-search.store';
import { areDeepEqual } from 'core/utils/object';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientSelect } from 'src/components/Form/ClientSelect';
import { CompanySelect } from 'src/components/Form/CompanySelect';
import { LabelSelect } from 'src/components/Form/LabelsSelect';
import { TaskStateSelect } from 'src/components/Form/TaskStateSelect';
import { TaskTypeSelect } from 'src/components/Form/TaskTypeSelect';
import { UserSelect } from 'src/components/Form/UserSelect';
import { ZoneSelect } from 'src/components/Form/ZoneSelect';
import { classes } from 'src/utils/classes';
import { formHasValueForRequiredFields } from 'src/utils/form';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TASK_SORT_TYPES = Object.values(TaskSortType).filter(function (type) {
  return type !== 'id';
});

function valueOrUndefined(value) {
  if (!value) {
    return;
  }

  if (Array.isArray(value) && value.length === 0) {
    return;
  }

  return value;
}

export var TaskFiltersForm = function TaskFiltersForm(_ref) {
  var _localSearch$filters2, _localSearch$filters3, _localSearch$filters4, _localSearch$filters5, _localSearch$filters6, _localSearch$filters7, _localSearch$filters8, _localSearch$filters9, _localSearch$filters10, _localSearch$filters11, _localSearch$filters12, _localSearch$filters13, _localSearch$filters14, _localSearch$filters15, _localSearch$filters16, _localSearch$filters17, _localSearch$filters18, _localSearch$filters19, _localSearch$filters20, _localSearch$filters21, _localSearch$filters22, _localSearch$filters23, _localSearch$filters24;

  var visible = _ref.visible,
      contains = _ref.contains;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _getTaskSearchesStore = getTaskSearchesStore(),
      isLoading = _getTaskSearchesStore.isLoading,
      currentSearch = _getTaskSearchesStore.currentSearch,
      localSearch = _getTaskSearchesStore.localSearch,
      setLocalSearch = _getTaskSearchesStore.setLocalSearch,
      createTaskSearch = _getTaskSearchesStore.createTaskSearch,
      updateTaskSearch = _getTaskSearchesStore.updateTaskSearch,
      deleteTaskSearch = _getTaskSearchesStore.deleteTaskSearch;

  var _useState = useState(new Date()),
      changedAt = _useState[0],
      setChangedAt = _useState[1];

  var hasChanges = useMemo(function () {
    return !areDeepEqual({
      filters: localSearch.filters,
      sort: localSearch.sort
    }, getFiltersFromForm());
  }, [localSearch, changedAt]);
  var hasUnsavedChanges = useMemo(function () {
    if (!currentSearch) {
      return true;
    }

    return !areDeepEqual({
      filters: currentSearch.filters,
      sort: currentSearch.sort
    }, getFiltersFromForm());
  }, [currentSearch, changedAt]);

  function onSave() {
    return _onSave.apply(this, arguments);
  }

  function _onSave() {
    _onSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var title, filters;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              title = form.getFieldValue('title');
              filters = getFiltersFromForm();
              _context.prev = 2;

              if (!currentSearch) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return updateTaskSearch(currentSearch.id, _objectSpread({
                title: title
              }, filters));

            case 6:
              _context.next = 10;
              break;

            case 8:
              _context.next = 10;
              return createTaskSearch(_objectSpread({
                title: title
              }, filters));

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              message.error(t('unknownError'));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));
    return _onSave.apply(this, arguments);
  }

  function getFiltersFromForm() {
    var _values$deadline, _values$deadline2, _values$createdAt, _values$createdAt2, _values$updatedAt, _values$updatedAt2, _values$closedAt, _values$closedAt2, _values$sortBy, _values$sortDir;

    var values = form.getFieldsValue();
    return {
      filters: {
        types: valueOrUndefined(values.types),
        states: valueOrUndefined(values.states),
        reference: valueOrUndefined(values.reference),
        contains: valueOrUndefined(values.contains),
        assigneeIds: valueOrUndefined(values.assigneeIds),
        reviewerIds: valueOrUndefined(values.reviewerIds),
        hasDeadline: values.hasDeadline !== undefined ? values.hasDeadline === 1 : undefined,
        deadlineFrom: (_values$deadline = values.deadline) !== null && _values$deadline !== void 0 && _values$deadline[0] ? values.deadline[0].startOf('day').toISOString() : undefined,
        deadlineTo: (_values$deadline2 = values.deadline) !== null && _values$deadline2 !== void 0 && _values$deadline2[1] ? values.deadline[1].endOf('day').toISOString() : undefined,
        labelIds: valueOrUndefined(values.labelIds),
        zoneIds: valueOrUndefined(values.zoneIds),
        companyIds: valueOrUndefined(values.companyIds),
        clientIds: valueOrUndefined(values.clientIds),
        createdFrom: (_values$createdAt = values.createdAt) !== null && _values$createdAt !== void 0 && _values$createdAt[0] ? values.createdAt[0].startOf('day').toISOString() : undefined,
        createdTo: (_values$createdAt2 = values.createdAt) !== null && _values$createdAt2 !== void 0 && _values$createdAt2[1] ? values.createdAt[1].endOf('day').toISOString() : undefined,
        updatedFrom: (_values$updatedAt = values.updatedAt) !== null && _values$updatedAt !== void 0 && _values$updatedAt[0] ? values.updatedAt[0].startOf('day').toISOString() : undefined,
        updatedTo: (_values$updatedAt2 = values.updatedAt) !== null && _values$updatedAt2 !== void 0 && _values$updatedAt2[1] ? values.updatedAt[1].endOf('day').toISOString() : undefined,
        closedFrom: (_values$closedAt = values.closedAt) !== null && _values$closedAt !== void 0 && _values$closedAt[0] ? values.closedAt[0].startOf('day').toISOString() : undefined,
        closedTo: (_values$closedAt2 = values.closedAt) !== null && _values$closedAt2 !== void 0 && _values$closedAt2[1] ? values.closedAt[1].endOf('day').toISOString() : undefined
      },
      sort: {
        sortBy: (_values$sortBy = values.sortBy) !== null && _values$sortBy !== void 0 ? _values$sortBy : TaskSortType.CreatedAt,
        sortDir: (_values$sortDir = values.sortDir) !== null && _values$sortDir !== void 0 ? _values$sortDir : SortDir.Desc
      }
    };
  }

  function onChange() {
    setLocalSearch(getFiltersFromForm());
  }

  function clearFilters() {
    form.resetFields();
    form.setFieldsValue({
      title: currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.title,
      sortBy: TaskSortType.CreatedAt,
      sortDir: SortDir.Desc
    });
    setLocalSearch({
      filters: {},
      sort: {
        sortBy: TaskSortType.CreatedAt,
        sortDir: SortDir.Desc
      }
    });
    setChangedAt(new Date());
  }

  useEffect(function () {
    form.resetFields();

    if (currentSearch) {
      var _currentSearch$filter, _currentSearch$filter2;

      form.setFieldsValue(_objectSpread(_objectSpread(_objectSpread({
        title: currentSearch.title
      }, currentSearch.filters), currentSearch.sort), {}, {
        hasDeadline: (currentSearch === null || currentSearch === void 0 ? void 0 : (_currentSearch$filter = currentSearch.filters) === null || _currentSearch$filter === void 0 ? void 0 : _currentSearch$filter.hasDeadline) !== undefined ? currentSearch !== null && currentSearch !== void 0 && (_currentSearch$filter2 = currentSearch.filters) !== null && _currentSearch$filter2 !== void 0 && _currentSearch$filter2.hasDeadline ? 1 : 0 : undefined,
        // Dates
        deadline: currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.deadlineFrom && currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.deadlineTo ? [moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.deadlineFrom), moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.deadlineTo)] : undefined,
        createdAt: currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.createdFrom && currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.createdTo ? [moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.createdFrom), moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.createdTo)] : undefined,
        updatedAt: currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.updatedFrom && currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.updatedTo ? [moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.updatedFrom), moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.updatedTo)] : undefined,
        closedAt: currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.closedFrom && currentSearch !== null && currentSearch !== void 0 && currentSearch.filters.closedTo ? [moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.closedFrom), moment(currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.filters.closedTo)] : undefined
      }));
    } else {
      form.setFieldsValue({
        sortBy: TaskSortType.CreatedAt,
        sortDir: SortDir.Desc
      });
    }

    setChangedAt(new Date());
  }, [currentSearch]);
  useEffect(function () {
    var _localSearch$filters;

    var value = valueOrUndefined(contains);

    if (value !== ((_localSearch$filters = localSearch.filters) === null || _localSearch$filters === void 0 ? void 0 : _localSearch$filters.contains)) {
      form.setFieldsValue({
        contains: value
      });
      setLocalSearch(_objectSpread(_objectSpread({}, localSearch), {}, {
        filters: _objectSpread(_objectSpread({}, localSearch.filters), {}, {
          contains: value
        })
      }));
      setChangedAt(new Date());
    }
  }, [contains]);
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Collapse, {
      activeKey: visible ? 'form' : 'none',
      children: /*#__PURE__*/_jsx(Collapse.Panel, {
        header: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsxs(Form, {
          form: form,
          colon: false,
          onValuesChange: function onValuesChange() {
            return setChangedAt(new Date());
          },
          onFinish: onChange,
          children: [/*#__PURE__*/_jsxs(Row, {
            justify: "space-between",
            className: "search-form",
            children: [/*#__PURE__*/_jsx(Space, {
              align: "center",
              children: /*#__PURE__*/_jsxs(Space, {
                size: 0,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "title",
                  label: /*#__PURE__*/_jsx(SaveOutlined, {}),
                  children: /*#__PURE__*/_jsx(Input, {
                    placeholder: t('tasksList.filtersTitlePlaceholder')
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  shouldUpdate: true,
                  children: function children() {
                    return /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      disabled: !hasUnsavedChanges || !formHasValueForRequiredFields(form, 'title'),
                      onClick: onSave,
                      loading: isLoading,
                      children: t('save')
                    });
                  }
                })]
              })
            }), /*#__PURE__*/_jsx("div", {
              children: currentSearch && /*#__PURE__*/_jsx(Popconfirm, {
                getPopupContainer: function getPopupContainer(trigger) {
                  return trigger.parentElement;
                },
                title: t('areYouSure'),
                icon: /*#__PURE__*/_jsx(QuestionCircleOutlined, {
                  style: {
                    color: 'red'
                  }
                }),
                okText: t('yes'),
                cancelText: t('cancel'),
                onConfirm: function onConfirm() {
                  return deleteTaskSearch(currentSearch.id);
                },
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  danger: true,
                  disabled: isLoading,
                  children: t('delete')
                })
              })
            })]
          }), /*#__PURE__*/_jsxs(Row, {
            gutter: 24,
            wrap: true,
            children: [/*#__PURE__*/_jsxs(Col, {
              xxl: 6,
              xs: 12,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "types",
                className: classes({
                  active: ((_localSearch$filters2 = localSearch.filters) === null || _localSearch$filters2 === void 0 ? void 0 : (_localSearch$filters3 = _localSearch$filters2.types) === null || _localSearch$filters3 === void 0 ? void 0 : _localSearch$filters3.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.type.label'),
                  children: /*#__PURE__*/_jsx(BlockOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(TaskTypeSelect, {
                  isMultiple: true,
                  allowClear: true,
                  placeholder: t('form.task.type.filter')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "states",
                className: classes({
                  active: ((_localSearch$filters4 = localSearch.filters) === null || _localSearch$filters4 === void 0 ? void 0 : (_localSearch$filters5 = _localSearch$filters4.states) === null || _localSearch$filters5 === void 0 ? void 0 : _localSearch$filters5.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.state.label'),
                  children: /*#__PURE__*/_jsx(ProjectOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(TaskStateSelect, {
                  isMultiple: true,
                  allowClear: true,
                  placeholder: t('form.task.state.filter')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "reference",
                className: classes({
                  active: !!((_localSearch$filters6 = localSearch.filters) !== null && _localSearch$filters6 !== void 0 && _localSearch$filters6.reference)
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.reference.label'),
                  children: /*#__PURE__*/_jsx(KeyOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(Input, {
                  placeholder: t('form.task.reference.filter'),
                  allowClear: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "contains",
                className: classes({
                  active: !!((_localSearch$filters7 = localSearch.filters) !== null && _localSearch$filters7 !== void 0 && _localSearch$filters7.contains)
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.content.label'),
                  children: /*#__PURE__*/_jsx(AlignCenterOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(Input, {
                  placeholder: t('form.task.content.filter'),
                  allowClear: true
                })
              })]
            }), /*#__PURE__*/_jsxs(Col, {
              xxl: 6,
              xs: 12,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "assigneeIds",
                className: classes({
                  active: ((_localSearch$filters8 = localSearch.filters) === null || _localSearch$filters8 === void 0 ? void 0 : (_localSearch$filters9 = _localSearch$filters8.assigneeIds) === null || _localSearch$filters9 === void 0 ? void 0 : _localSearch$filters9.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.assignee.label'),
                  children: /*#__PURE__*/_jsx(UserOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(UserSelect, {
                  isMultiple: true,
                  allowNone: true,
                  allowClear: true,
                  placeholder: t('form.task.assignee.filter'),
                  emptyMessage: t('form.task.assignee.empty')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "reviewerIds",
                className: classes({
                  active: ((_localSearch$filters10 = localSearch.filters) === null || _localSearch$filters10 === void 0 ? void 0 : (_localSearch$filters11 = _localSearch$filters10.reviewerIds) === null || _localSearch$filters11 === void 0 ? void 0 : _localSearch$filters11.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.reviewer.label'),
                  children: /*#__PURE__*/_jsx(UserSwitchOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(UserSelect, {
                  isMultiple: true,
                  allowNone: true,
                  allowClear: true,
                  placeholder: t('form.task.reviewer.filter'),
                  emptyMessage: t('form.task.reviewer.empty')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "hasDeadline",
                className: classes({
                  active: ((_localSearch$filters12 = localSearch.filters) === null || _localSearch$filters12 === void 0 ? void 0 : _localSearch$filters12.hasDeadline) !== undefined
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.deadline.label'),
                  children: /*#__PURE__*/_jsx(HourglassOutlined, {})
                }),
                children: /*#__PURE__*/_jsxs(Select, {
                  allowClear: true,
                  placeholder: t('form.task.deadline.filter'),
                  children: [/*#__PURE__*/_jsx(Select.Option, {
                    value: 0,
                    children: t('form.task.deadline.without')
                  }), /*#__PURE__*/_jsx(Select.Option, {
                    value: 1,
                    children: t('form.task.deadline.with')
                  })]
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "deadline",
                className: classes({
                  active: !!((_localSearch$filters13 = localSearch.filters) !== null && _localSearch$filters13 !== void 0 && _localSearch$filters13.deadlineFrom)
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.deadline.label'),
                  children: /*#__PURE__*/_jsx(HourglassOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(DatePicker.RangePicker, {
                  allowClear: true,
                  placeholder: [t('form.task.deadline.placeholderFrom'), t('form.task.deadline.placeholderTo')]
                })
              })]
            }), /*#__PURE__*/_jsxs(Col, {
              xxl: 6,
              xs: 12,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "labelIds",
                className: classes({
                  active: ((_localSearch$filters14 = localSearch.filters) === null || _localSearch$filters14 === void 0 ? void 0 : (_localSearch$filters15 = _localSearch$filters14.labelIds) === null || _localSearch$filters15 === void 0 ? void 0 : _localSearch$filters15.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.labels.label'),
                  children: /*#__PURE__*/_jsx(TagsOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(LabelSelect, {
                  isMultiple: true,
                  allowClear: true,
                  placeholder: t('form.task.labels.filter')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "zoneIds",
                className: classes({
                  active: ((_localSearch$filters16 = localSearch.filters) === null || _localSearch$filters16 === void 0 ? void 0 : (_localSearch$filters17 = _localSearch$filters16.zoneIds) === null || _localSearch$filters17 === void 0 ? void 0 : _localSearch$filters17.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.zone.label'),
                  children: /*#__PURE__*/_jsx(EnvironmentOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(ZoneSelect, {
                  isMultiple: true,
                  allowClear: true,
                  placeholder: t('form.task.zone.filter')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "companyIds",
                className: classes({
                  active: ((_localSearch$filters18 = localSearch.filters) === null || _localSearch$filters18 === void 0 ? void 0 : (_localSearch$filters19 = _localSearch$filters18.companyIds) === null || _localSearch$filters19 === void 0 ? void 0 : _localSearch$filters19.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.company.label'),
                  children: /*#__PURE__*/_jsx(AppstoreOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(CompanySelect, {
                  isMultiple: true,
                  allowClear: true,
                  placeholder: t('form.task.company.filter')
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "clientIds",
                className: classes({
                  active: ((_localSearch$filters20 = localSearch.filters) === null || _localSearch$filters20 === void 0 ? void 0 : (_localSearch$filters21 = _localSearch$filters20.clientIds) === null || _localSearch$filters21 === void 0 ? void 0 : _localSearch$filters21.length) > 0
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.client.label'),
                  children: /*#__PURE__*/_jsx(AppstoreOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(ClientSelect, {
                  isMultiple: true,
                  allowClear: true,
                  placeholder: t('form.task.client.filter')
                })
              })]
            }), /*#__PURE__*/_jsxs(Col, {
              xxl: 6,
              xs: 12,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "createdAt",
                className: classes({
                  active: !!((_localSearch$filters22 = localSearch.filters) !== null && _localSearch$filters22 !== void 0 && _localSearch$filters22.createdFrom)
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.createdAt.label'),
                  children: /*#__PURE__*/_jsx(ClockCircleOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(DatePicker.RangePicker, {
                  allowClear: true,
                  placeholder: [t('form.task.createdAt.placeholderFrom'), t('form.task.createdAt.placeholderTo')]
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "updatedAt",
                className: classes({
                  active: !!((_localSearch$filters23 = localSearch.filters) !== null && _localSearch$filters23 !== void 0 && _localSearch$filters23.updatedFrom)
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.updatedAt.label'),
                  children: /*#__PURE__*/_jsx(FieldTimeOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(DatePicker.RangePicker, {
                  allowClear: true,
                  placeholder: [t('form.task.updatedAt.placeholderFrom'), t('form.task.updatedAt.placeholderTo')]
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "closedAt",
                className: classes({
                  active: !!((_localSearch$filters24 = localSearch.filters) !== null && _localSearch$filters24 !== void 0 && _localSearch$filters24.closedFrom)
                }),
                label: /*#__PURE__*/_jsx(Tooltip, {
                  title: t('form.task.closedAt.label'),
                  children: /*#__PURE__*/_jsx(CheckOutlined, {})
                }),
                children: /*#__PURE__*/_jsx(DatePicker.RangePicker, {
                  allowClear: true,
                  placeholder: [t('form.task.closedAt.placeholderFrom'), t('form.task.closedAt.placeholderTo')]
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "sort-items",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "sortBy",
                  className: "sort-type-item",
                  label: /*#__PURE__*/_jsx(Tooltip, {
                    title: t('form.task.closedAt.label'),
                    children: /*#__PURE__*/_jsx(SortDescendingOutlined, {})
                  }),
                  children: /*#__PURE__*/_jsx(Select, {
                    placeholder: t('form.column.sortBy.placeholder'),
                    children: TASK_SORT_TYPES.map(function (option) {
                      return /*#__PURE__*/_jsx(Select.Option, {
                        value: option,
                        children: t("form.task.".concat(option, ".label"))
                      }, option);
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "sortDir",
                  className: "sort-dir-item",
                  children: /*#__PURE__*/_jsxs(Radio.Group, {
                    children: [/*#__PURE__*/_jsx(Radio.Button, {
                      value: SortDir.Asc,
                      children: "ASC"
                    }), /*#__PURE__*/_jsx(Radio.Button, {
                      value: SortDir.Desc,
                      children: "DESC"
                    })]
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/_jsxs(Row, {
            justify: "end",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: clearFilters,
              children: t('clear')
            }), /*#__PURE__*/_jsx(Form.Item, {
              shouldUpdate: true,
              children: function children() {
                return /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  htmlType: "submit",
                  icon: /*#__PURE__*/_jsx(SearchOutlined, {}),
                  disabled: !hasChanges,
                  onClick: onChange,
                  children: t('search')
                });
              }
            })]
          })]
        })
      }, "form")
    })
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "FiltersForm__Container",
  componentId: "sc-16korii-0"
})([".ant-collapse{border-bottom:none;border-radius:0;border-left:0;border-right:0;}.ant-collapse-item{border:none;.ant-collapse-content{border-radius:0;background-color:#fafafa;padding-bottom:24px;}.ant-collapse-header{display:none;}}.ant-collapse-content-active{border-bottom:1px solid #d9d9d9;}.ant-picker{width:100%;}.ant-collapse-content-box{padding-bottom:0;}.search-form{width:100%;justify-content:space-between;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid ", ";.ant-form-item{margin:0;}}.sort-items{display:flex;.sort-type-item{width:calc(100% - 130px);.ant-form-item-control{max-width:calc(100% - 34px);}}.sort-dir-item{min-width:130px;}}.ant-form-item{&.active{.ant-form-item-label .anticon{color:", ";}}}"], Colors.lighterGrey, Colors.primary);